import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-red-50" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <h2 className="text-3xl md:text-5xl font-black text-red-600 mb-4 text-center" data-id="element-229">
          🚨 ATENCIÓN PADRES
        </h2>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-230">
          <p className="text-xl font-bold mb-3" data-id="element-231">Si tu hijo…</p>
          <ul className="space-y-2" data-id="element-232">
            <li className="flex items-start" data-id="element-233">
              <span className="text-red-600 font-bold mr-3" data-id="element-234">❌</span>
              <span className="text-lg" data-id="element-235">Pide dinero constantemente</span>
            </li>
            <li className="flex items-start" data-id="element-236">
              <span className="text-red-600 font-bold mr-3" data-id="element-237">❌</span>
              <span className="text-lg" data-id="element-238">No entiende el valor de las cosas</span>
            </li>
            <li className="flex items-start" data-id="element-239">
              <span className="text-red-600 font-bold mr-3" data-id="element-240">❌</span>
              <span className="text-lg" data-id="element-241">Gasta sin pensar</span>
            </li>
            <li className="flex items-start" data-id="element-242">
              <span className="text-red-600 font-bold mr-3" data-id="element-243">❌</span>
              <span className="text-lg" data-id="element-244">No sabe ahorrar</span>
            </li>
            <li className="flex items-start" data-id="element-245">
              <span className="text-red-600 font-bold mr-3" data-id="element-246">❌</span>
              <span className="text-lg" data-id="element-247">Cree que el dinero "aparece"</span>
            </li>
          </ul>

          <div className="mt-4 p-4 bg-yellow-100 border-l-4 border-yellow-500" data-id="element-248">
            <p className="text-xl font-bold" data-id="element-249">👉 Esto no es casualidad.</p>
            <p className="text-xl font-bold mt-1" data-id="element-250">
              Es falta de educación financiera.
            </p>
          </div>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-251">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-252">
            ⚠️ LA VERDAD QUE NADIE TE DIJO
          </h3>
          <p className="text-xl mb-2" data-id="element-253">
            A nosotros nunca nos enseñaron sobre dinero…
          </p>
          <p className="text-xl mb-2" data-id="element-254">Y sin darnos cuenta…</p>
          <p className="text-xl font-bold" data-id="element-255">
            estamos criando una nueva generación igual.
          </p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg" data-id="element-256">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-257">
            😔 ¿EL RESULTADO?
          </h3>
          <p className="text-xl mb-2" data-id="element-258">Adultos con:</p>
          <ul className="space-y-2" data-id="element-259">
            <li className="flex items-start" data-id="element-260">
              <span className="text-red-600 font-bold mr-3" data-id="element-261">❌</span>
              <span className="text-lg" data-id="element-262">Deudas</span>
            </li>
            <li className="flex items-start" data-id="element-263">
              <span className="text-red-600 font-bold mr-3" data-id="element-264">❌</span>
              <span className="text-lg" data-id="element-265">Estrés financiero</span>
            </li>
            <li className="flex items-start" data-id="element-266">
              <span className="text-red-600 font-bold mr-3" data-id="element-267">❌</span>
              <span className="text-lg" data-id="element-268">Mala relación con el dinero</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}
export default ProblemSection;